export const createSingleDocument = (payload?: any) => ({
    type: "@saga/CREATE_DOCUMENT",
    payload
});

